export const branding = {
  tenantId: 'genesis',
  name: 'GENESIS',
  tagline: 'Centro de especialidades',
  primaryColor: '#174E52',
  secondaryColor: '#D7AD63',
  logo: '/genesis-mark.svg',
  city: 'Quito',
};

const PRODUCT_HOSTS = new Set(['vyedocs', 'vyendelo', 'admin', 'auth', 'www', 'kong']);

/** Alias del host (genesis.vyecom.com → genesis). En local usa GENESIS. */
export function clinicTenantId(): string {
  if (typeof location === 'undefined') return branding.tenantId;
  const host = location.hostname.split(':')[0].toLowerCase();
  if (!host || host === 'localhost' || host === '127.0.0.1') {
    const localTenant = import.meta.env.VITE_CLINIC_TENANT_ID;
    return /^[a-z0-9-]{1,64}$/.test(localTenant || '') ? localTenant : branding.tenantId;
  }
  const alias = host.replace(/\.apps\.vyecom\.com$/, '').replace(/\.vyecom\.com$/, '');
  if (!alias || PRODUCT_HOSTS.has(alias) || alias === host) return branding.tenantId;
  return alias;
}

export const auth = {
  // Local development must use the isolated local Keycloak. Never fall back to
  // the production identity provider when a developer forgets .env.local.
  url: import.meta.env.VITE_KEYCLOAK_URL ||
    (import.meta.env.DEV ? 'http://localhost:8083' : 'https://auth.vyecom.com'),
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'vyecom',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'vyedocs-shell',
  requireLogin: false,
};

/**
 * Mismos paths en local y prod.
 * Local: Vite proxea a 4201/4202 (producto).
 * Prod: nginx proxea /mf/dictation y /mf/documents a vyedocs;
 * /mf/vyendelo al producto Vyendelo.
 */
export const remotes = {
  dictation: '/mf/dictation/remoteEntry.json',
  documents: '/mf/documents/remoteEntry.json',
  vyendelo: '/mf/vyendelo/remoteEntry.json',
};
